<template lang="pug">
  div(class="dual-container")
    h2 Interested in using MathSmith App ...
    div
      div(
        class="dual-section left-15 dsection-left"
        @mouseover="index = 1"
        @mouseleave="index=0"
      ) 
        p(v-if="index == 2" class="dual-shorthand left-15") IN AN EXISTING COURSE?
        h3(v-else) in your existing Canvas course?

        div(v-if="index==1")
          span Install the MathSmith app into your Canvas course for &nbsp
          span &nbsp by following &nbsp
          a(href="https://canvas.mathsmithllc.com/install" target="_blank") these steps
          span .    
      div(
        class="dual-section right-15 dsection-right"
        @mouseover="index = 2"
        @mouseleave="index=0"
      ) 
        p(v-if="index == 1" class="dual-shorthand right-15") IN AN IMPORTED COURSE?
        h3(v-else) by importing our Canvas course?
        
        div(v-if="index==2")
          span Import one of our ready-made courses. Select a course from &nbsp
          a(@click.prevent.stop="scrollToElement('course-imports')" style="text-decoration: underline; cursor: pointer;") our list
          span &nbsp and download the &nbsp
          span(style="font-style: italic;") Canvas import file. 
</template>

<script>
export default {
  name: "DualSim",
  data() {
    return {
      index: 0
    };
  },
  methods: {
    scrollToElement(id) {
      const el = document.getElementById(id);
      el.scrollIntoView({ behavior: "smooth" });
    }
  }
};
</script>

<style>
.dual-container {
  text-align: center;
  padding: 0;
  margin: 0;
  position: relative;
}

.dual-section {
  transition: all 0.3s ease;
  position: absolute;
  top: 2em;
  width: 42%;
  height: 4.5em;
  display: inline-block;
  padding: 1em;
  vertical-align: center;
  border-radius: 10px;
  background-color: var(--button-blue);
  color: #fff;
  z-index: 0;
}

.dual-section:hover {
  width: 70%;
  top: 1.75em;
  color: var(--darkest-blue);
  background-color: var(--light-blue-three);
  border: 2px solid var(--button-blue);
  z-index: 1;
  box-shadow: rgba(0, 0, 0, 0.25) 0px 9px 9.2px 0.8px;
  height: 6em;
}

.dual-shorthand {
  font-size: 1.15em;
  font-weight: 700;
  vertical-align: center;
  width: 35%;
  margin: 0;
  position: absolute;
}

.dual-section-left {
  left: 1em;
}

.dual-section-right {
  right: 1em;
}
</style>
